<template>
  <div>
    <Breadcrumb :options="breadcrumb" />
    <div class="mainss">
      <div class="left">
        <el-steps direction="vertical">
          <el-step
            :title="c.addtime + '更新日志'"
            v-for="(c, i) in remarks"
            :key="'remark' + i"
          >
            <template slot="description">
              <div class="cons">
                <!-- <div class="tit">{{ c.title }}</div> -->
                <div class="word" v-if="!c.cons">{{ c.content }}</div>
                <div class="word" v-if="c.cons">
                  <p v-for="(v, j) in c.cons" :key="'con' + j">{{ v }}</p>
                </div>
              </div>
            </template>
          </el-step>
        </el-steps>
      </div>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: "syslog",
      breadcrumb: [{ name: "帮助中心", path: `` }, { name: "更新日志" }],
      getOptionUrl: "index",
      remarks: [
        {
          addtime: "2026年9月28日",
          cons: [
            "1、PC端-车辆管理-车辆列表/挂车管理， 车辆证件/保险的图片展示由2列调整为3列；",
            "2、PC端-维保管理-维保列表，维修前和维修后图片由2列调整为3列；",
            "3、PC端-订单管理-已完成状态的订单支持自定义导出；",
            "4、PC端-车辆管理-新增车辆维护子模块，超级管理员和车务有该模块；",
            "5、PC端-财务管理-预支款管理，批量打款只对已选择的打款类型操作打款；",
            "6、PC端-系统设置-新增系统操作日志查询功能；",
            "7、PC端-系统设置-新增维护机构配置；",
            "8、移动端-司机端-新增车辆维护按钮，司机提交车辆维护记录；",
            "9、移动端-司机端-我的车辆，对所有保险单据进行隐藏。",
          ],
        },
        {
          addtime: "2026年9月16日",
          cons: [
            "1、PC端-车辆管理-车辆列表/挂车管理， 车辆证件/保险上传的照片数量增加到15张；",
            "2、PC端-车务权限-新增订单管理模块，只能查看不可以修改；",
            "3、PC端-车务权限-新增维保管理模块，只能查看不可以修改；",
            "4、维修商端-在录入维修单的时候可以显示出车辆所属车队长；",
            "5、维保详情-维修前和维修后的照片改为分别上传，维修前和维修后最多上传5张照片；",
            "6、移动端-订单列表-返回列表定位功能修复；",
            "7、移动端-签约管理-劳动合同签约，公司名称处添加公章。",
          ],
        },
        {
          addtime: "2026年9月2日",
          cons: [
            "1、移动端-订单管理-普通订单-添加订单，客户名称改成模糊搜索；",
            "2、PC端-财务管理-预支款管理-打款记录中的“全部”拆分成3条；",
            "3、PC端-财务管理-预支款管理-打款可以选择多车同时打款，选择多车同时打款，默认预支款余额归零；",
            "4、PC端-财务管理-预支款管理-优化逻辑：若余额为正数，选择全部打款时打款金额固定为对应余额的负值；",
            "5、系统名称变更为恩琦运输管理系统，系统logo替换。",
          ],
        },
        {
          addtime: "2026年7月23日",
          cons: [
            "1、PC端-人员管理-司机管理，开户银行、持卡人、银行账号改为必填项；",
            "2、PC端+移动端-维修商端-维修单添加页面，新增行驶里程录入和上传行驶里程照片，两个字段均为必填项；",
            "3、PC端-维保管理-维保列表中新增行驶里程字段，维保详情新增行驶里程、行驶里程照片。",
          ],
        },
        {
          addtime: "2026年7月17日",
          cons: [
            "1、人员管理-司机管理-司机详情，新增司机押金输入框；",
            "2、人员管理-司机管理-离职的司机可以上传司机押金打款凭证；",
            "3、人员管理-司机管理-司机列表，新增押金金额、押金状态（未扣除、已扣除、已归还三种状态）；",
            "4、财务管理-预支款管理-有押金的司机在绑定车辆后自动形成一条打款记录；",
            "5、会计权限新增司机管理模块，对在职司机是查看权限，对离职司机有上传押金打款凭证权限。",
          ],
        },
        {
          addtime: "2026年6月25日",
          cons: [
            "1、司机端-出车费用表，现金加油支持上传PDF文件；",
            "2、PC端-财务管理-油气费汇总表，现金加油上传的资料（图片或PDF），支持按车辆按日期（装货日期）导出；",
            "3、PC端-财务管理-出车费用汇总表，出车费用票据支持按车辆按日期（装货日期）导出。",
          ],
        },
        {
          addtime: "2026年6月2日",
          cons: [
            "1、PC端-人员管理-司机管理-增加开户银行、持卡人、银行账号字段；",
            "2、PC端-财务管理-预支款管理，列表增加持卡人字段；",
            "3、PC端-车辆管理-车辆详情页去掉开户银行、银行账号字段。",
          ],
        },
        {
          addtime: "2026年5月30日",
          cons: [
            "1、PC端-财务管理-预支款管理，新增三项费用统计功能，分别为司机提成、差旅费和其他费用；",
            "2、PC端-财务管理-预支款管理，打款记录新增打款类型选择，选项分别为全部、司机提成、差旅费、其他费用，选择全部时，打款金额不可编辑；",
            "3、PC端-财务管理-预支款管理，打款记录列表新增打款类型字段；",
            "4、PC端-财务管理-预支款管理，列表新增开户银行和银行账号字段；",
            "5、PC端-车辆管理-车辆列表，车辆详情新增开户银行和银行账号字段；",
            "6、PC端-车辆管理-新增车辆类型字段，车辆类型为小车；",
            "7、PC端-财务管理-预支款管理， 将车辆类型为小车的车辆屏蔽不显示。",
          ],
        },
        {
          addtime: "2026年5月22日",
          cons: [
            "1、PC端/移动端-合同管理，新增司机提成、提成金额、用餐补贴、住宿补贴字段，司机提成为选择项（有/无），默认为无，选择是，可以设置提成金额，用餐补贴、住宿补贴为选填项；",
            "2、PC端/移动端-合同派单-在选车页面新增司机提成选项，默认为无，车队长根据实际情况选择；",
            "3、移动端-合同订单添加-新增司机提成选项，默认为无，车队长根据实际情况选择；",
            "4、PC端-系统设置-出车费用配置-对司机提成、用餐补贴、住宿补贴字段进行固定，不可隐藏；",
            "5、合同管理中设置有司机提成、用餐补贴、住宿补贴的，将合同管理中设置的相应金额，显示到出车费用表中；",
            "6、审核逻辑调整：出车费用表中的司机提成、用餐补贴、住宿补贴，司机、车队长、会计均不可以修改，超级管理员可以修改已完成订单的司机提成、用餐补贴、住宿补贴；",
            "7、优化车辆添加车牌号的格式，保证相同车牌号的车辆可以正常添加。",
          ],
        },
        {
          addtime: "2026年4月11日",
          cons: ["1、司机端-隐藏掉维保管理按钮。"],
        },
        {
          addtime: "2026年4月2日",
          cons: [
            "1、移动端-普通订单-雇佣车辆订单创建，将车牌号和客户名称改为模糊搜索；",
            "2、移动端-合同订单-雇佣车辆订单创建，将车牌号改为模糊搜索。",
          ],
        },
        {
          addtime: "2026年3月9日",
          cons: ["1、优化了PC端-财务管理-油气费汇总表检索栏的部分功能。"],
        },
        {
          addtime: "2026年2月4日",
          cons: [
            "1、PC端-财务管理-油气费汇总表，筛选栏新增车队长筛选项；",
            "2、PC端-维保管理-维保列表，新增2000条/页展示选项。",
          ],
        },
        {
          addtime: "2025年12月30日",
          cons: [
            "1、PC端-维保列表-车队长筛选改为多选；",
            "2、PC端-固定费用支出表-去掉打短押运工资字段；",
            "3、PC端-车队利润表-增加月份字段；",
            "4、PC端-车队运营统计表-增加加油升数、行驶里程字段。油气费汇总表、队长工资表页面返回定位功能。",
          ],
        },
        {
          addtime: "2025年11月05日",
          cons: [
            "1、预支款管理-打款记录，筛选栏，月份选择改为时间选择，新增车种选项，增加导出按钮；",
            "2、预支款管理-打款记录，新增总费用详情；",
            "3、报销管理-调整报销审核流程，新流程为：提交人-会计审核（韩玲）-老板审核-出纳打款（时国婧）；",
            "4、司机可以在提交审核之前可以修改装卸货单；",
            "5、车队看板-运费总额分别展示公司运费和司机运费，利润额分别展示公司利润和司机利润；",
            "6、运营分析-看板数据调整；",
            "7、运营看板-将运费额和毛利额按照公司和司机分别展示；",
            "8、系统头像设置为默认头像（恩琦logo）；",
            "9、财务管理-出车费用汇总表-费用明细-增加订单编号；",
            "10、电子签-劳动合同签约增加公章；",
            "11、将部分车辆定位装置的里程数据接入到系统中。",
          ],
        },
        {
          addtime: "2025年9月29日",
          cons: [
            "1、PC端-普通订单-已完成状态，新增装卸货地址筛选项； ",
            "2、PC端-油气费汇总表-新增列表导出功能； ",
            "3、PC端-预支款管理-新增预支款列表导出功能； ",
            "4、权限调整-关闭车队经理、会计对已完成订单出车费用表的修改功能；  ",
            "5、出车费用汇总表、固定费用支出表、油气费汇总表日志中新增系统操作者的ID；",
            "6、车队运营统计表在目标达成率之后加上综合油耗，计算公式：综合油耗=当月加油升数÷当月行驶公里数×100；",
            "7、合同添加、修改、查看，新增是否含税的选项；",
            "8、PC端-人员管理-司机和押运员证件详情页面，面包屑导航新增司机和押运员姓名；",
            "9、PC端-预支款管理-修改打款时间接口参数。",
          ],
        },
        {
          addtime: "2025年8月29日",
          cons: [
            "1、优化了考勤管理、预支款管理、固定费用支出表、出车费用汇总表、油气费汇总表、队长工资表页面返回定位功能。",
          ],
        },
        {
          addtime: "2025年8月15日",
          cons: [
            "1、毛利额计算去掉亏吨金额和信息费，直接使用运费额；",
            "2、超过合同量以后暂停派单，可以通过修改合同量以后继续派单；",
            "3、合同列表-订单列表，新增时间段选择，导出装卸货磅单，列表中字段新增装货日期；",
            "4、合同管理-添加合同选择客户名称用模糊搜索；",
            "5、合同派单的时候，合同编号之后展示客户名称；",
            "6、维修商恢复只能录入近7日的维修订单。",
          ],
        },
        {
          addtime: "2025年7月31日",
          cons: ["1、移动端-出车费用表，里程登记部分改为必填。"],
        },
        {
          addtime: "2025年7月28日",
          cons: [
            "1、企业经营驾驶舱-维修分析新增页面钻取功能；",
            "2、移动端-新增出车费用表上传出车费用票据功能，对出车费用表进行分区管理；",
            "3、维修管理-录入维修单，去掉时间选择只允许选择7天内的限制。",
          ],
        },
        {
          addtime: "2025年7月3日",
          cons: [
            "1、PC端-维修管理-筛选项去掉维修单位下拉选择，改为模糊搜索；",
            "2、PC端-普通订单、合同订单可以将已完成状态订单的过磅单导出，车队长、会计、超级管理员有该权限。",
          ],
        },
        {
          addtime: "2025年6月13日",
          cons: [
            "1、维保管理-PC端维保列表新增维修商筛选；",
            "2、PC端列表页，在列表最左侧加上序号；",
            "3、PC端列表页，查看后返回，滚动条固定到原位置；",
            "4、财务管理-固定费用支出表、出车费用汇总表、车队利润表、月度统计表，新增导出功能，出车费用汇总表上加上车种筛选，单车明细加上导出功能；",
            "5、维保管理，维修商录入维修订单，恢复维修日期只能选择7日内的。",
          ],
        },
        {
          addtime: "2025年6月4日",
          cons: ["1、维保管理，维修商录入维修订单，维修日期可以选择当日之前的任何时间；"],
        },
        {
          addtime: "2025年5月27日",
          cons: [
            "1、PC端列表页，对筛选栏和表头进行固定，不随列表滚动；",
            "2、维修管理，维修商通过PC端和移动端录入维修订单只能选择7日内的日期；",
            "3、维修商端，移动端加条件限制防止重复提交。",
          ],
        },
        {
          addtime: "2025年5月10日",
          cons: [
            "1、新增维修管理-订单回收站模块，只有超管、机务有删除订单的权限，删除维修订单需要备注删除原因；",
            "2、车务权限下增加签约管理模块；",
            `3、合同管理PC端-新增托运人、装货地址、卸货地址筛选。`,
          ],
        },
        {
          addtime: "2025年4月25日",
          cons: [
            "1、车队经理端-查看订单后返回，保留搜索条件；",
            "2、电子签-安全生产责任书签约-安全员签约更改签约人，总经理改为安全科长，分管负责人改为安全员；",
            "3、订单回收站-新增车队长筛选；",
            "4、订单回收站-新增已完成/未完成订单筛选；",
            "5、司机端-待接单状态的订单去掉删除按钮；",
            "6、挂车管理-新增状态管理（在用、停用、报废）。",
          ],
        },
        {
          addtime: "2025年4月7日",
          cons: [
            "1、订单管理-订单列表，各订单状态表头字段增加车队长，展示车队长姓名，包含普通订单、合同订单以及合同管理操作栏查看订单；",
            `2、司机端-普通订单-列表页和详情页去掉司机单价。`,
          ],
        },
        {
          addtime: "2025年3月18日",
          cons: [
            "1、优化移动端已完成订单初始展示条数（默认20条）；",
            "2、车辆管理-添加车辆新增查重功能；",
            "3、车辆管理模块优化，已派单的车辆不能删除，未派单的车辆可以删除。",
            "4、预支款管理-费用详情，总费用增加合计；",
            "5、预支款管理-打款时间精确到时分秒；",
            "6、预支款管理-费用详情添加日期（装货日期）；",
            "7、预支款管理-列表页加上序号；",
            "8、出车费用汇总表-增加预支款类型筛选项；",
            "9、出车费用汇总表-单车出车明细表，新增时间段选择；",
            "10、订单管理-订单列表（含普通订单、合同订单）调整装卸货地址的宽度。",
          ],
        },
        {
          addtime: "2025年3月4日",
          cons: [
            "1、优化电子签模块页面展示效果（提交前自动恢复初始比例）；",
            `2、调整合同订单-全部订单的操作权限。`,
          ],
        },
        {
          addtime: "2025年2月26日",
          cons: [
            "1、普通订单和合同订单，表头增加司机姓名和货物名称字段；",
            `2、车队利润表新增亏吨金额字段，调整运费统计表、公司利润表、车队利润表的计算公式，公式如下：
            运费统计表计算公式：毛利额=司机运费-出车费用-亏吨金额-信息费
            公司利润表计算公式：
            公司利润=公司运费-司机运费；单车平均利润=公司利润÷车辆数量；
            车队利润表计算公式：
            毛利润 = 司机运费 - 信息费 - 出车费用 - 固定费用 - 维修费用 - 亏吨金额；
            净利润 = 毛利润 + 补差 - 司机工资 - 押运工资；`,
            "3、车队经理和车队长权限下，待审核的订单新增页面返回定位功能。",
          ],
        },
        {
          addtime: "2025年2月19日",
          cons: [
            "1、会计的权限，已完成的订单不能再修改过磅单和费用；",
            "2、调整证件、保险到期提醒方式；",
            "3、财务管理-预支款管理，金额列居中；",
            "4、调整列表页面数据展示条数，最高每页展示500条；",
            "5、车队长对订单审核通过的车辆，方可再行派单；",
            "6、队长可以对待审核的订单可以修改过磅单、装货重量、出车费用表，还可对订单进行驳回，驳回输入驳回意见，退到司机处修改，驳回的订单退到已送达状态，司机修改后再次提交审核。车队经理只对订单做审核，会计只有修改的权限；",
            "7、新增审核节点（车队经理），新流程为司机→车队长→车队经理→会计。",
          ],
        },
        {
          addtime: "2025年1月21日",
          cons: [
            "1、新增材料员、出纳员、办公室主任三个岗位的电子签；",
            "2、人员管理处新增无犯罪记录证明，司机和押运证件加上到期提醒；",
            "3、新增订单回收站功能，删除的订单进入订单回收站中展示，删除的订单必须备注删除原因后方可删除。",
          ],
        },
        {
          addtime: "2025年1月18日",
          cons: [
            "1、新增公司利润表；",
            "2、车队运营统计表，运费总额的取值调整为司机运费；",
            "3、运费统计表，计算毛利额用司机运费计算，公司运费和公司单价仅用于展示；",
            "4、车队利润表，运费总额的取值调整为司机运费；",
            "5、月度统计表，新增公司利润字段，放在月份之后，利润总额改为车队利润；",
            "6、预支款管理：预支款打款详情中体现费用详情，费用详情为两个打款时间的订单汇总；",
            "7、预支款管理：打款记录列表展示备注信息，车牌号左侧添加序号；",
            "8、维修商端，加条件限制防止重复提交；",
            "9、维修商端，选择车辆时候可以选择挂车；",
            "10、维修商端，提交以后编辑按钮失效，如有修改需要机务管理员修改。",
          ],
        },
        {
          addtime: "2025年1月8日",
          cons: [
            `1、合同管理员在创建合同时，可以录入司机单价，队长在派单时无需填写；`,
            "2、预支款扣除逻辑调整，队长审核通过后扣除预支款；",
            "3、预支款处新增车种、预支款类型筛选；",
            "4、预支款展示列表新增3种每页展示条数（100条/页，150条/页，200条/页）；",
            "5、预支款页面对搜索条件、页码、每页展示条数等进行固定；",
            "6、预支款打款凭证上传改为选填；",
            "7、周勇的权限上加上可以自行配置货物名称；",
            `8、预支款余额显示在司机端工作台页面。`,
          ],
        },
      ],
    };
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="less" scoped>
.mainss {
  display: flex;
  justify-content: space-between;

  .left {
    // width: 48.5%;
    width: 100%;
    padding: 20px 0 20px 25px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.03);
    border-radius: 5px 5px 5px 5px;

    /deep/.el-steps {
      .el-step__icon.is-text {
        background: #2691ff;
        border: 0;
      }

      .el-step__icon {
        width: 12px;
        height: 12px;
      }

      .is-vertical .el-step__line {
        width: 2px;
        top: 15px;
        bottom: 0px;
        left: 5px;
      }

      .el-step__line {
        background: #e6e8eb;
      }

      .el-step__icon-inner {
        display: none;
      }

      .is-vertical .el-step__head {
        padding-top: 4px;
        flex-grow: 0;
        width: 14px;
      }

      .el-step__title {
        font-size: 15px;
        font-weight: 400;
        color: #303133;
      }

      .el-step__description {
        padding-right: 0;
      }
    }

    .cons {
      width: 96%;
      margin: 10px 0;
      padding: 15px 20px;
      background: #f7f7f7;
      border-radius: 5px;
      opacity: 1;

      .tit {
        font-size: 15px;
        font-weight: 400;
        color: #909399;
      }

      .word {
        //margin-top: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #303133;
      }
    }
  }

  .right {
    width: 49%;
  }
}

/deep/ .el-form {
  background-color: #fff;
  padding: 25px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form-item {
    margin-bottom: 0px;
  }

  .el-textarea__inner {
    height: 100px;
    background: #f7f8fa;
    border: none;
    // color: #909399;
    font-family: "Microsoft Yahei";
    font-size: 14px;
  }
}

.btns {
  margin: 25px 0 20px 25px;
  // margin: 0 auto;
}
</style>
